// extracted by mini-css-extract-plugin
export var indeterminate = "_3r-5";
export var md = "_3r-4";
export var semantic = "_3r-6";
export var sm = "_3r-3";
export var text = "_3r-7";
export var toggleInput = "_3r-0";
export var toggleSwitch = "_3r-1";
export var xs = "_3r-2";